import { useContext, useEffect, useRef, useState } from 'react';
import { LocaleContext } from './App';
import './BlogPost.css';
import { getDateStr, sanitizeStr } from './util';

export const BlogPost = ({postData, management, showNextPostBtn, showPrevPostBtn, onBackClick,
        onNextPostClick, onPrevPostClick}) => {
    const locale = useContext(LocaleContext);


    // RENDER:

    return (
        <div className="blog_post">
            <div className="blog_post_content">
                { !management ?
                    <div className="blog_post_back_btn_box">
                        <NavigateButtonBackwards text={locale.msgs.BLOG_POSTS} noBorder={true}
                                onClick={onBackClick} />
                    </div>
                :
                    null
                }

                <div className="blog_post_date text_small_2">{getDateStr(postData.date)}</div>

                <div className="blog_post_headline text_big_big">{postData.headline}</div>

                { postData.image_url ? 
                    <img className="blog_post_image" src={postData.image_url} alt={postData.image_alt_text}></img>
                :
                    null
                }

                <div className="blog_post_main_text text_2" dangerouslySetInnerHTML={{ __html: sanitizeStr(postData.main_text_html)}}></div>

                { !management && (showPrevPostBtn || showNextPostBtn) ?
                    <div className="blog_post_bottom_btn_box">

                        <NavigateButtonBackwards text={locale.msgs.PREVIOUS_POST} onClick={onPrevPostClick}
                                hidden={!showPrevPostBtn} />

                        <NavigateButtonForwards text={locale.msgs.NEXT_POST} onClick={onNextPostClick}
                                hidden={!showNextPostBtn} />

                    </div>
                :
                    null
                }

            </div>
        </div>
    )
}

const NavigateButtonBackwards = ({text, onClick, noBorder, hidden}) => {
    return (
        <div className={"navigate_btn navigate_btn_backwards noselect" + (noBorder ? " navigate_btn_no_border" : "")}
                onClick={onClick} style={{visibility: !hidden ? "visible" : "hidden"}}>
            <img src="/common/icon_arrow-left-black.svg" className="navigate_btn_icon"></img>
            <div className="navigate_btn_text text_small_2">{text}</div>
        </div>
    )
}

const NavigateButtonForwards = ({text, onClick, noBorder, hidden}) => {
    return (
        <div className={"navigate_btn navigate_btn_forwards noselect" + (noBorder ? " navigate_btn_no_border" : "")}
                onClick={onClick} style={{visibility: !hidden ? "visible" : "hidden"}}>
            <div className="navigate_btn_text text_small_2">{text}</div>
            <img src="/common/icon_arrow-right-black.svg" className="navigate_btn_icon"></img>
        </div>
    )
}
